<template>
    <div>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-cash</v-icon>
                <p style="color: white;">RECUPERACIONES</p>
            </v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="validForm" lazy-validation>
                    <v-row justify="center">
                        <v-col col="12" md="6">
                            <div>
                                <span class="type-label-style">
                                    Proveedor:
                                </span>
                                <v-radio-group v-model="tipopago" :rules="[v => !!v || 'Opción requerida']">
                                    <v-radio label="ÚNICO" style="text-align: center;"
                                             value="1"></v-radio>
                                    <v-radio label="DIFERIDO" style="text-align: center;"
                                             value="2"></v-radio>
                                </v-radio-group>
                            </div>
                            <v-divider class="ma-1"></v-divider>
                            <div v-if="tipopago == 1">
                                <span class="type-label-style">Fecha Estimada de Pago:</span>
                                <v-menu ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="true"
                                        transition="scale-transition"
                                        offset-y
                                        maxlength="16"
                                        max-width="290px"
                                        min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dateFormatted"
                                                      outlined
                                                      readonly
                                                      v-bind="attrs"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date"
                                                   locale="es-mx"
                                                   :min="minfecha"
                                                   @input="menu = false"></v-date-picker>
                                </v-menu>
                                <v-divider class="ma-1"></v-divider>
                            </div>
                            <div v-if="tipopago == 2">
                                <span class="type-label-style">
                                    Forma de Pago:
                                </span>
                                <v-radio-group v-model="formapago" :rules="tipopago == 2 ? [v => !!v || 'Opción requerida'] : []" @change="VerificarPago()">
                                    <v-radio label="Número de pagos" style="text-align: center;"
                                             value="1"></v-radio>
                                    <v-radio label="Periodos de Pago" style="text-align: center;"
                                             value="2"></v-radio>
                                </v-radio-group>
                                <v-divider class="ma-1"></v-divider>
                            </div>
                            <div v-if="formapago == 2">
                                <span class="type-label-style">
                                    Plazos de pago:
                                </span>
                                <v-select v-model="plazo"
                                          :items="plazos"
                                          item-text="text"
                                          item-value="valor"
                                          :menu-props="{ maxHeight: '400' }"
                                          label="Seleccione un plazo"
                                          :rules="formapago == 2 ? [v => !!v || 'Selección requerida'] : []"
                                          @change="(valor) => changeplazo(valor)"
                                          dense
                                          solo
                                          persistent-hint></v-select>
                            </div>
                            <div v-if="formapago == 1 || plazo > 0">
                                <span class="type-label-style">
                                    Pagos:
                                </span>
                                <v-text-field style="width:100%"
                                              v-model="pagos"
                                              maxlength="2"
                                              outlined
                                              :rules="[rules.required, rules.valor]"
                                              @keypress="filter($event)">
                                </v-text-field>
                            </div>
                            <div disabled>
                                <span>Monto de Negociación:</span>
                                <v-text-field style="width:100%"
                                              v-model="dulpimonto"
                                              outlined
                                              readonly
                                              @blur="Foco"
                                              autofocus>
                                </v-text-field>
                            </div>
                            <div v-if="parseInt(pagos) > 0">
                                <div v-for="(item, i) in pagar" :key="i">
                                    <span>Pago {{i + 1}}:</span>
                                    <v-text-field style="width:100%"
                                                  v-model="item.monto"
                                                  outlined
                                                  maxlength="8"
                                                  :rules="[rules.required, rules.montomin]"
                                                  @keypress="filter($event)">
                                    </v-text-field>
                                    <span>Fecha de pago {{i + 1}}:</span>
                                    <v-menu ref="item.menu"
                                            v-model="item.menu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            maxlength="16"
                                            max-width="290px"
                                            min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="item.fecha"
                                                          outlined
                                                          v-bind="attrs"
                                                          readonly
                                                          :rules="[rules.required]"
                                                          v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="item.date"
                                                       locale="es-mx"
                                                       :min="minfecha"
                                                       @input="item.menu = false; CambiarFecha(i, item.date)"></v-date-picker>
                                    </v-menu>
                                </div>
                                <span style="color: red;" v-show="validaplazo">El total de la suma no coincide con el monto de la negociación</span>
                            </div>
                            <v-divider class="ma-1"></v-divider>
                            <div>
                                <span>Observaciones:</span>
                                <v-textarea :counter="500"
                                            :rules="[rules.required, rules.minimo, rules.maximo]"
                                            outlined
                                            v-model="observacion"
                                            required
                                            name="input-7-4"
                                            v-on:blur="observacion = observacion.trim()"></v-textarea>
                            </div>
                            <v-divider class="ma-1"></v-divider>
                        </v-col>
                        
                    </v-row>
                    <v-row justify="center">
                        <v-btn class="ma-2"
                               color="primary"
                               title="Guardar"
                               @click="Guardar()">
                            <span style='color: white;'>Guardar</span>
                        </v-btn>
                        <v-btn class="ma-2"
                               title="Limpiar"
                               color="default"
                               @click="Limpiar()">
                           Limpiar
                        </v-btn>
                        <v-btn class="ma-2"
                               color="#FF4081"
                               title="Cancelar"
                               @click="cancelar()">
                            <span style='color: white;'>Cancelar</span>
                        </v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    import Reporte from "@/services/ExpJur/ExpJur.service.js";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import moment from "moment";

    export default {
        title() {
            return this.$route.meta.title
        },
        data() {
            return {
                showcargando: true,
                idtercero: 0,
                tipopago: 0,
                validForm: true,
                menu: '',
                dateFormatted: '',//this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                date: '',//(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                minfecha: '',//new Date().toISOString(),
                monto: 0,
                dulpimonto: 0,
                observacion: '',
                formapago: 0,
                pagos: '',
                pagar: [],
                plazos: [
                    { valor: 1, text: 'SEMANAL' },
                    { valor: 2, text: 'QUINCENAL' },
                    { valor: 3, text: 'MENSUAL' },
                    { valor: 4, text: 'TRIMESTRAL' }
                ],
                plazo: 0,
                validaplazo: false,
                validaplazos: false,
                ngid: 0,
                permiso: false,
                //Reglas
                rules: {
                    required: value => !!value || 'Campo requerido',
                    minimo: value => {
                        if (value == null) {
                            return true
                        }
                        else {
                            if (value.length <= 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                    maximo: value => {
                        if (value == null) {
                            return true
                        }
                        else {
                            if (value.length > 500) {
                                return 'Máximo 500 caracteres'
                            }
                            else
                                return true
                        }
                    },
                    montomin: value => {
                        if (value == null) {
                            return true
                        }
                        else {
                            if (value <= 0) {
                                return 'Monto incorrecto'
                            }
                            if (value > 5000000)
                                return 'Monto incorrecto'
                            else
                                return true
                        }
                    },
                    valor: value => value <= 40 || 'No puede generar más de 40 pagos',
                },
            }
        },
        watch: {
            tipopago() {
                this.pagar = [];
                this.pagos = '';
                this.plazo = 0;
                this.formapago = 0;

            },
            date(val) {
                this.dateFormatted = this.formatDate(this.date)
                
            },            
            async pagos(val) {
                this.pagar = [];
                let dato;
                if(this.monto != null)
                    dato = this.monto.replace(/([^0-9\.\-])/g, '');
                let division = await this.roundToHalf(dato / this.pagos);
                let ultimo = dato - (division * this.pagos);
                if (val <= 40) {
                    if (this.plazo == 0) {
                        for (var i = 1; i <= this.pagos; i++) {
                            if (i == this.pagos)
                                division = division + ultimo;
                            this.pagar.push({
                                menu: '',
                                monto: division,
                                fecha: moment().format("DD[/]MM[/]YYYY"),
                                date: moment().format("YYYY[-]MM[-]DD"),
                            });
                        }
                    }
                    else {
                        let aumento = 0;
                        let tipo = '';

                        switch (this.plazo) {
                            case 1:
                                aumento = 7;
                                tipo = 'days';
                                break;
                            case 2:
                                aumento = 15;
                                tipo = 'days';
                                break;
                            case 3:
                                aumento = 1;
                                tipo = 'months';
                                break;
                            case 4:
                                aumento = 1;
                                tipo = 'quarters';
                                break;
                        }
                        for (var i = 1; i <= this.pagos; i++) {
                            if (i == this.pagos)
                                division = division + ultimo;
                            this.pagar.push({
                                menu: '',
                                monto: division,
                                fecha: moment().add(aumento * i, tipo).format("DD[/]MM[/]YYYY"),
                                date: moment().add(aumento * i, tipo).format("YYYY[-]MM[-]DD"),
                            });
                        }
                    }
                }
                else {
                    this.validaplazo = false;
                }
            }
        },
        async mounted() {
            let clavetercero = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.changeReporteMenuOption(clavetercero.urlname);
            moment.locale("es");
            this.date = moment().format("YYYY[-]MM[-]DD");
            this.minfecha = moment().format("YYYY[-]MM[-]DD");

            this.idtercero = clavetercero.d3id;
            this.DatosNegociacion();
            this.showcargando = false;
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '304').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            Foco() {
                this.dulpimonto = this.monto;
            },
            CambiarFecha(i, date) {
                
                if (i == 0 && this.formapago == '2') {
                    let fecha = moment(date);
                    if (this.pagar[0].fecha != this.formatDate(date)) {
                        
                        for (var x = 1; x < this.pagar.length; x++) {
                            let dias = 0;
                            let tipo = '';
                            let actualiza;
                            switch (this.plazo) {
                                case 1:
                                    dias = 7;
                                    tipo = 'days';
                                    break;
                                case 2:
                                    dias = 15;
                                    tipo = 'days';
                                    break;
                                case 3:
                                    dias = 1;
                                    tipo = 'months';
                                    break;
                                case 4:
                                    dias = 1;
                                    tipo = 'quarters';
                                    break;
                            }
                            
                            actualiza = fecha.add(dias, tipo);
                            this.pagar[x].fecha = actualiza.format("DD[/]MM[/]YYYY");
                            this.pagar[x].date = actualiza.format("YYYY[-]MM[-]DD");
                        }
                    }

                }
                this.pagar[i].fecha = this.formatDate(date);
            },
            async Guardar() {
                this.validaplazo = false
                this.validaplazos = false;
                let frmdata = new FormData();
                let total = 0;
                frmdata.append("ngid", this.ngid);
                frmdata.append("nrtipopago", this.tipopago);
                frmdata.append("nrmontoneg", this.monto.replace(/([^0-9\.\-])/g, ''));
                frmdata.append("nrfhpago", this.parseDate(this.dateFormatted));
                frmdata.append("nrobs", this.observacion);

                if (this.tipopago == 2) {
                    frmdata.append("nrforpago", this.formapago);
                    if (this.formapago == 2) {
                        if (this.plazo != 0)
                            frmdata.append("nrplazopago", this.plazos[this.plazo - 1].text);
                        else
                            this.validaplazos = false;
                    }

                    frmdata.append("datos", JSON.stringify(this.pagar));
                    for (let x in this.pagar) {
                        total += parseFloat(this.pagar[x].monto);
                    }
                    if (total != this.monto.replace(/([^0-9\.\-])/g, '') && this.pagar.length > 0)
                        this.validaplazo = true;
                }
                

                if (this.$refs.form.validate() && this.validaplazo == false && this.validaplazos == false) {
                    this.$swal({
                        title: "Guardando la recuperación, espere un momento...",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    Reporte.InsertaRecuperacion(frmdata).then(data => {
                        this.$swal.close();
                        if (data[0].success == 'true') {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito",
                                text: "La recuperación se guardó correctamente",
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                showConfirmButton: true,
                                timer: 4000,
                            }).then(() => {
                               // this.$router.push({ name: `ListadoNegociaciones` });
                                this.$router.go(-1);
                            });
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        
                    });
                }
            },
            changeplazo(valor) {
                this.pagar = [];
                this.pagos = '';
            },
            VerificarPago() {
                this.pagar = [];
                this.pagos = '';
                this.plazo = 0;
            },
            Limpiar() {
                this.showcargando = true;
                this.validaplazo = false;
                this.tipopago = 0;
                this.pagar = [];
                this.pagos = '';
                this.plazo = 0;
                this.formapago = 0;
                this.$refs.form.reset();
                this.DatosNegociacion();
                this.showcargando = false;
                this.observacion = '';
                moment.locale("es");
                this.date = moment().format("YYYY[-]MM[-]DD");
                this.minfecha = moment().format("YYYY[-]MM[-]DD");
            },
            cancelar() {
                //this.$router.push({ name: `ListadoNegociaciones` });
                this.$router.go(-1);

            },
            async DatosNegociacion() {
                let formdata = new FormData();
                formdata.append("d3id", this.idtercero);
                await Reporte.ObtenerDatosNegociacionUltimo(this, formdata).then(data => {
                    console.log(data);
                    this.monto = MetodosGenerales.regresarValorMoneda(data[0].Monto, "$");
                    this.dulpimonto = this.monto;
                    this.ngid = data[0].ngid;
                });
            },
            roundToHalf(value) {
                var converted = parseFloat(value); // Make sure we have a number
                var decimal = (converted - parseInt(converted, 10));
                decimal = Math.round(decimal * 10);
                if (decimal == 5) { return (parseInt(converted, 10)); }
                if ((decimal < 1) || (decimal > 5)) {

                    return Math.round(converted);
                } else {

                    return parseInt(converted, 10);
                }
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            formatDate(date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            parseDate(date) {
                if (!date) return null

                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        }
    }
</script>